// @ts-nocheck
import { useState } from "react";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import LineClamp from "../../../../positions/components/LineClamp";
import { useEffect } from "react";

export const EditableCell = ({
  value,
  onChange,
  renderedValue,
  disableEditing = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value || "");

  const handleBlur = () => {
    setIsEditing(false);
    onChange(tempValue?.trim());
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setIsEditing(false);
      onChange(tempValue.trim());
    } else if (e.key === "Escape") {
      setTempValue(value || "");
      setIsEditing(false);
    }
  };

  useEffect(() => {
    setTempValue(value);
  }, [value, isEditing]);

  return isEditing && !disableEditing ? (
    <TextField
      value={tempValue}
      onChange={(e) => setTempValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      size="small"
      autoFocus
      variant="standard"
      sx={{
        width: "100%",
        backgroundColor: "#2A2A2A",
        "& .MuiInputBase-input": {
          color: "white",
          fontSize: "0.875rem",
          padding: "4px",
        },
      }}
    />
  ) : (
    <div
      onClick={() => {
        if (disableEditing) return;
        setIsEditing(true);
      }}
      style={{ cursor: "pointer", width: "100%" }}
    >
      <LineClamp text={renderedValue || value || "—"} maxLines={1} />
    </div>
  );
};

EditableCell.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  renderedValue: PropTypes.any,
  disableEditing: PropTypes.bool,
};